import React from 'react'

class SVGraphics extends React.Component {

  getViewBox = (svgname) => {
    switch (svgname) {
      case 'glass':
        return '0 0 30 30'
      case 'fail':
      case 'play':
      case 'pause':
      case 'arrowBlackUp':
      case 'arrowBlackDown':
      case 'note':
        return '0 0 35 35'
      case 'edit':
      case 'update':
      case 'blackEye':
      case 'logOut':
      case 'trash':
      case 'email':
      case 'devices':
      case 'sitePlace':
      case 'countryLocation':
      case 'gantt':
      case 'sites':
      case 'chambers':
      case 'orders':
      case 'users':
      case 'configurations':
      case 'logout':
      case 'gloveBox':
      case 'power':
      case 'calendar':
      case 'refresh':
      case 'refresh-white':
      case 'clock':
      case 'document-small':
      case 'total-small':
      case 'plus-circle':
      case 'plus-circle-white':
      case 'lock-user':
        return '0 0 24 24'
      case 'line':
        return '0 0 1 42'
      case 'alert-triangle':
        return '0 0 38 38'
      case 'activityLevel':
        return '0 0 23 20'
      case 'toogleRight':
        return '0 0 24 16'
      case 'eye':
        return '0 0 16 16'
      case 'link':
        return '0 0 32 32'
      case 'files':
        return '0 0 72 72'
      case 'back':
        return '0 0 50 50'
      case 'alert':
        return '0 0 15 15'
      case 'total':
        return '0 0 73 72'
      case 'document':
        return '0 0 72 72'
      case 'loader':
        return '0 0 72 72'
      case 'approved':
        return '0 0 72 72'
      case 'check-circle':
        return '0 0 31 30'
      case 'x-circle':
        return '0 0 31 30'
      case 'red-warning-circle':
        return '0 0 24 25'
      case 'folder':
        return '0 0 48 48'
      case 'delete-icon':
        return '0 0 427 427'
      case 'check-circle2':
        return '0 0 40 40'
      case 'circle-truck':
        return '0 0 28 29'
      case 'injector':
        return '0 0 18 18'
      case 'chambers-small':
        return '0 0 24 24'
      case 'leftArrow':
        return '0 0 36 36'
      case 'rightArrow':
        return '0 0 36 36'
      case 'ellipsis':
        return '0 0 23 14'
      case 'notes':
        return '0 0 56 56'
      case 'user':
        return '0 0 24 24'
      case 'pin':
        return '0 0 24 25'
      case 'reset':
        return '0 0 24 24'

      default:
        return '0 0 24 24'
    }
  }


  getPath = (svgname) => {
      const mainColor = "#17597C"
    switch (svgname) {
      case 'delete-icon':
        return (
          <g>
            <path
              fill={mainColor}
              d='M272.4 154.7c-5.5 0-10 4.5-10 10v189c0 5.5 4.5 10 10 10s10-4.5 10-10v-189c0-5.5-4.5-10-10-10zM154.4 154.7c-5.5 0-10 4.5-10 10v189c0 5.5 4.5 10 10 10s10-4.5 10-10v-189c0-5.5-4.5-10-10-10z'
              className='st0'
            />
            <path
              fill={mainColor}
              d='M68.4 127.1v246.4c0 14.6 5.3 28.2 14.7 38.1 9.3 9.8 22.2 15.4 35.7 15.4H308c13.5 0 26.4-5.6 35.7-15.4 9.3-9.8 14.7-23.5 14.7-38.1V127.1c18.5-4.9 30.6-22.8 28.1-41.9-2.5-19-18.7-33.2-37.9-33.2h-51.2V39.5c.1-10.5-4.1-20.6-11.5-28C278.4 4 268.3-.1 257.8 0H169c-10.5-.1-20.6 4-28.1 11.5-7.4 7.4-11.6 17.5-11.5 28V52H78.2C59 52 42.8 66.2 40.3 85.3c-2.5 19 9.6 36.9 28.1 41.8zM308 407H118.8c-17.1 0-30.4-14.7-30.4-33.5V128h250v245.5c0 18.8-13.3 33.5-30.4 33.5zM149.4 39.5c-.1-5.2 2-10.2 5.7-13.9 3.7-3.7 8.7-5.7 13.9-5.6h88.8c5.2-.1 10.2 1.9 13.9 5.6 3.7 3.7 5.7 8.7 5.7 13.9V52h-128V39.5zM78.2 72h270.4c9.9 0 18 8.1 18 18s-8.1 18-18 18H78.2c-9.9 0-18-8.1-18-18s8.1-18 18-18z'
              className='st0'
            />
            <path
              fill={mainColor}
              d='M213.4 154.7c-5.5 0-10 4.5-10 10v189c0 5.5 4.5 10 10 10s10-4.5 10-10v-189c0-5.5-4.5-10-10-10z'
              className='st0'
            />
          </g>
        )
      case 'notes':
        return (
          <g fill='none'>
            <path
              d='M53.9003 24.4996V50.8996C53.9003 52.5565 52.5572 53.8996 50.9003 53.8996H5.10034C3.44349 53.8996 2.10034 52.5565 2.10034 50.8996V5.09961C2.10034 3.44275 3.44349 2.09961 5.10034 2.09961H31.5003M53.9003 24.4996L31.5003 2.09961M53.9003 24.4996H34.5003C32.8435 24.4996 31.5003 23.1565 31.5003 21.4996V2.09961'
              stroke={mainColor}
              strokeWidth='1.2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M18.9233 30.1797V38H17.8813L13.9443 31.9683V38H12.9077V30.1797H13.9443L17.8975 36.2275V30.1797H18.9233ZM20.3467 35.1587V35.0352C20.3467 34.6162 20.4076 34.2277 20.5293 33.8696C20.651 33.508 20.8265 33.1947 21.0557 32.9297C21.2848 32.6611 21.5623 32.4535 21.8882 32.3066C22.214 32.1562 22.5793 32.0811 22.9839 32.0811C23.3921 32.0811 23.7591 32.1562 24.085 32.3066C24.4144 32.4535 24.6937 32.6611 24.9229 32.9297C25.1556 33.1947 25.3328 33.508 25.4546 33.8696C25.5763 34.2277 25.6372 34.6162 25.6372 35.0352V35.1587C25.6372 35.5776 25.5763 35.9661 25.4546 36.3242C25.3328 36.6823 25.1556 36.9956 24.9229 37.2642C24.6937 37.5291 24.4162 37.7368 24.0903 37.8872C23.7681 38.034 23.4028 38.1074 22.9946 38.1074C22.5864 38.1074 22.2194 38.034 21.8936 37.8872C21.5677 37.7368 21.2884 37.5291 21.0557 37.2642C20.8265 36.9956 20.651 36.6823 20.5293 36.3242C20.4076 35.9661 20.3467 35.5776 20.3467 35.1587ZM21.3403 35.0352V35.1587C21.3403 35.4487 21.3743 35.7227 21.4424 35.9805C21.5104 36.2347 21.6125 36.4603 21.7485 36.6572C21.8882 36.8542 22.0618 37.0099 22.2695 37.1245C22.4772 37.2355 22.7189 37.291 22.9946 37.291C23.2668 37.291 23.5049 37.2355 23.709 37.1245C23.9167 37.0099 24.0885 36.8542 24.2246 36.6572C24.3607 36.4603 24.4627 36.2347 24.5308 35.9805C24.6024 35.7227 24.6382 35.4487 24.6382 35.1587V35.0352C24.6382 34.7487 24.6024 34.4784 24.5308 34.2241C24.4627 33.9663 24.3589 33.7389 24.2192 33.542C24.0832 33.3415 23.9113 33.1839 23.7036 33.0693C23.4995 32.9548 23.2596 32.8975 22.9839 32.8975C22.7118 32.8975 22.4718 32.9548 22.2642 33.0693C22.0601 33.1839 21.8882 33.3415 21.7485 33.542C21.6125 33.7389 21.5104 33.9663 21.4424 34.2241C21.3743 34.4784 21.3403 34.7487 21.3403 35.0352ZM29.3164 32.1885V32.9512H26.1743V32.1885H29.3164ZM27.2378 30.7759H28.2314V36.5605C28.2314 36.7575 28.2619 36.9061 28.3228 37.0063C28.3836 37.1066 28.4624 37.1729 28.5591 37.2051C28.6558 37.2373 28.7596 37.2534 28.8706 37.2534C28.953 37.2534 29.0389 37.2463 29.1284 37.2319C29.2215 37.214 29.2913 37.1997 29.3379 37.189L29.3433 38C29.2645 38.0251 29.1606 38.0483 29.0317 38.0698C28.9064 38.0949 28.7542 38.1074 28.5752 38.1074C28.3317 38.1074 28.1079 38.0591 27.9038 37.9624C27.6997 37.8657 27.5368 37.7046 27.415 37.479C27.2969 37.2498 27.2378 36.9419 27.2378 36.5552V30.7759ZM32.8936 38.1074C32.4889 38.1074 32.1219 38.0394 31.7925 37.9033C31.4666 37.7637 31.1855 37.5685 30.9492 37.3179C30.7165 37.0672 30.5374 36.77 30.4121 36.4263C30.2868 36.0825 30.2241 35.7065 30.2241 35.2983V35.0728C30.2241 34.6001 30.2939 34.1794 30.4336 33.8105C30.5732 33.4382 30.763 33.123 31.0029 32.8652C31.2428 32.6074 31.515 32.4123 31.8193 32.2798C32.1237 32.1473 32.4388 32.0811 32.7646 32.0811C33.18 32.0811 33.5381 32.1527 33.8389 32.2959C34.1432 32.4391 34.3921 32.6396 34.5854 32.8975C34.7788 33.1517 34.922 33.4525 35.0151 33.7998C35.1082 34.1436 35.1548 34.5195 35.1548 34.9277V35.3735H30.8149V34.5625H34.1611V34.4873C34.1468 34.2295 34.0931 33.9788 34 33.7354C33.9105 33.4919 33.7673 33.2913 33.5703 33.1338C33.3734 32.9762 33.1048 32.8975 32.7646 32.8975C32.5391 32.8975 32.3314 32.9458 32.1416 33.0425C31.9518 33.1356 31.7889 33.2752 31.6528 33.4614C31.5168 33.6476 31.4111 33.875 31.3359 34.1436C31.2607 34.4121 31.2231 34.7218 31.2231 35.0728V35.2983C31.2231 35.5741 31.2607 35.8337 31.3359 36.0771C31.4147 36.3171 31.5275 36.5283 31.6743 36.7109C31.8247 36.8936 32.0055 37.0368 32.2168 37.1406C32.4316 37.2445 32.6751 37.2964 32.9473 37.2964C33.2982 37.2964 33.5954 37.2248 33.8389 37.0815C34.0824 36.9383 34.2954 36.7467 34.478 36.5068L35.0796 36.9849C34.9543 37.1746 34.7949 37.3555 34.6016 37.5273C34.4082 37.6992 34.1701 37.8389 33.8872 37.9463C33.6079 38.0537 33.2767 38.1074 32.8936 38.1074ZM39.6987 36.4585C39.6987 36.3153 39.6665 36.1828 39.6021 36.061C39.5412 35.9357 39.4141 35.8229 39.2207 35.7227C39.0309 35.6188 38.7445 35.5293 38.3613 35.4541C38.0391 35.3861 37.7472 35.3055 37.4858 35.2124C37.228 35.1193 37.0078 35.0065 36.8252 34.874C36.6462 34.7415 36.5083 34.5858 36.4116 34.4067C36.3149 34.2277 36.2666 34.0182 36.2666 33.7783C36.2666 33.5492 36.3167 33.3325 36.417 33.1284C36.5208 32.9243 36.6659 32.7435 36.8521 32.5859C37.0418 32.4284 37.2692 32.3049 37.5342 32.2153C37.7992 32.1258 38.0946 32.0811 38.4204 32.0811C38.8859 32.0811 39.2834 32.1634 39.6128 32.3281C39.9422 32.4928 40.1947 32.7131 40.3701 32.9888C40.5456 33.2609 40.6333 33.5635 40.6333 33.8965H39.6396C39.6396 33.7354 39.5913 33.5796 39.4946 33.4292C39.4015 33.2752 39.2637 33.1481 39.0811 33.0479C38.902 32.9476 38.6818 32.8975 38.4204 32.8975C38.1447 32.8975 37.9209 32.9404 37.749 33.0264C37.5807 33.1087 37.4572 33.2144 37.3784 33.3433C37.3032 33.4722 37.2656 33.6082 37.2656 33.7515C37.2656 33.8589 37.2835 33.9556 37.3193 34.0415C37.3587 34.1239 37.4268 34.2008 37.5234 34.2725C37.6201 34.3405 37.7562 34.4049 37.9316 34.4658C38.1071 34.5267 38.3309 34.5876 38.603 34.6484C39.0793 34.7559 39.4714 34.8848 39.7793 35.0352C40.0872 35.1855 40.3164 35.37 40.4668 35.5884C40.6172 35.8068 40.6924 36.0718 40.6924 36.3833C40.6924 36.6375 40.6387 36.8703 40.5312 37.0815C40.4274 37.2928 40.2752 37.4754 40.0747 37.6294C39.8778 37.7798 39.6414 37.8979 39.3657 37.9839C39.0936 38.0662 38.7874 38.1074 38.4473 38.1074C37.9352 38.1074 37.502 38.0161 37.1475 37.8335C36.793 37.6509 36.5244 37.4146 36.3418 37.1245C36.1592 36.8345 36.0679 36.5283 36.0679 36.2061H37.0669C37.0812 36.4782 37.16 36.6948 37.3032 36.856C37.4465 37.0135 37.6219 37.1263 37.8296 37.1943C38.0373 37.2588 38.2432 37.291 38.4473 37.291C38.7194 37.291 38.9468 37.2552 39.1294 37.1836C39.3156 37.112 39.457 37.0135 39.5537 36.8882C39.6504 36.7629 39.6987 36.6196 39.6987 36.4585Z'
              fill={mainColor}
            />
          </g>
        )
      case 'user':
        return (
          <g fill='none'>
            <path
              d='M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'ellipsis':
        return (
          <g>
            <path
              d='M12 7C12.5523 7 13 7.27614 13 7C13 6.72386 12.5523 6 12 6C11.4477 6 11 6.72386 11 7C11 7.27614 11.4477 7 12 7Z'
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 3C12.5523 3 13 3.27614 13 3C13 2.72386 12.5523 2 12 2C11.4477 2 11 2.72386 11 3C11 3.27614 11.4477 3 12 3Z'
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 11C12.5523 11 13 11.2761 13 11C13 10.7239 12.5523 10 12 10C11.4477 10 11 10.7239 11 11C11 11.2761 11.4477 11 12 11Z'
              stroke='white'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'leftArrow':
        return (
          <g>
            <mask id='mask0_3007_13988' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='8' y='8' width='20' height='20'>
              <rect x='8' y='8' width='20' height='20' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_3007_13988)'>
              <path d='M20 23L15 18L20 13L21.062 14.062L17.125 18L21.062 21.938L20 23Z' fill='#293050' />
            </g>
          </g>
        )
      case 'rightArrow':
        return (
          <g>
            <mask id='mask0_3007_13982' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='8' y='8' width='20' height='20'>
              <rect x='8' y='8' width='20' height='20' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_3007_13982)'>
              <path d='M16 23L14.938 21.938L18.875 18L14.938 14.062L16 13L21 18L16 23Z' fill='#293050' />
            </g>
          </g>
        )

      case 'circle-truck':
        return (
          <g>
            <ellipse cx='14' cy='14.004' rx='14' ry='14.004' fill='#A07F59' />
            <rect x='6' y='3' width='18' height='18.0051' fill='url(#pattern0)' />
            <defs>
              <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
                <use xlinkHref='#image0_3007_13972' transform='scale(0.0100029 0.01)' />
              </pattern>
              <image
                id='image0_3007_13972'
                width='100'
                height='100'
                xlinkHref='data:image/png;base64,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'
              />
            </defs>
          </g>
        )
      case 'chambers-small':
        return (
          <g fill='none'>
            <path
              d='M12 8C16.9706 8 21 6.65685 21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5C3 6.65685 7.02944 8 12 8Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M3 5V19C3 20.66 7 22 12 22C17 22 21 20.66 21 19V5'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )

      case 'check-circle2':
        return (
          <g>
            <circle cx='20' cy='20' r='19' fill='white' stroke='#3B8B81' strokeWidth='2' />
            <path
              d='M30.8888 12.5547L16.8332 26.6102L10.4443 20.2214'
              fill='white'
              stroke='#3B8B81'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'glass':
        return (
          <g fill='none'>
            <path stroke='#F2F5FA' strokeWidth='2' d='M14 23c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9z' />
            <path stroke='#F2F5FA' strokeLinecap='round' strokeWidth='2' d='M22.867 22.775l3.768 3.768' />
          </g>
        )
      /*   case "alert-triangle":
                return (
                    <g fill="none">
                        <path d="M17.1498 6.4327L3.03312 29.9994C2.74207 30.5034 2.58807 31.0749 2.58644 31.6569C2.58481 32.2389 2.73561 32.8112 3.02383 33.3169C3.31206 33.8226 3.72767 34.2439 4.2293 34.5391C4.73094 34.8343 5.30112 34.993 5.88312 34.9994H34.1165C34.6985 34.993 35.2686 34.8343 35.7703 34.5391C36.2719 34.2439 36.6875 33.8226 36.9757 33.3169C37.264 32.8112 37.4148 32.2389 37.4131 31.6569C37.4115 31.0749 37.2575 30.5034 36.9665 29.9994L22.8498 6.4327C22.5527 5.94288 22.1343 5.5379 21.6351 5.25684C21.1359 4.97578 20.5727 4.82812 19.9998 4.82812C19.4269 4.82813 18.8637 4.97578 18.3645 5.25684C17.8653 5.5379 17.4469 5.94288 17.1498 6.4327Z" stroke="#17597C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M20 15V21.6667" stroke="#17597C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M20 28.334H20.0163" stroke="#17597C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                ); */
      case 'lock-user':
        return (
          <g fill='none'>
            <path
              d='M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'injector':
        return (
          <defs>
            <image
              id='image0_3247_14751'
              width='18'
              height='18'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEw0lEQVR4nO1dyW4UMRA1IMR/cAMJOHDlJxBkIYQAidjEKiTgCF8Cd3YJceIv+ALEBbGJKbfdGTtDGlWSQTOtXuzuttsd15PmFPd0j5/tqnqvZsIYwQhcqGtcqIRL9WeUqBWzqwhOkGXZERAq5VJn+AKh/oJQ627uRqhFlmWHuVR8SgiREgBAqEu4M4iUgABCXS0gZZtLfbPvZ4sWQKSETwjtlMDIIFJ6AKa5JUGdAn1IcYNiimeYTDiRUlHAMT/H1HqbsfFpTam60Pb9mkwwkVKtNV1mDdFmYokUVqo1TVDu8EkGkVKvNU1spPIuVzftFFaa7SApF/vQqSj7YpWkrPQxcUQKKz0utrhQG77T1aL3jzIlhhJSklQt9U1GlKRA+crE7GutDzLKtK9979GD2crsg4z1wr9J9TPLsgNsPwIMV2YfZJSNAal+7EtCoHgytjGY+wiuNscgyju4M5AMLsdnWTRkSH2jZkwnhFAhaJDrj6S+YzqWCkDnHrd+ZHNNU1Ko8DNMbZNULbAKkIjov+FgAolatX0P051CO8NwZxRU5susAmREudoZQj/hcnxuR7Oy9EVsVjvtDEMypmO4HJ8vIWWNVYCaGRyQMQUG9BJSKm1davdpGzOkflB2DQp2BTEFi8ArtveihriWZPy/NlGrRaTUdaWQbN6szlg0fI+1JuoqGUv2q3TL1EfAY6qJulpxfFUmCDHXGRPTyWmqrpaQMqmrb6KIGUmqFguyp9qY4OKZ8DnqlIAoAvioKHvy4LhFJ6/bZFOQC9Q+HLeognyjOiP157hFlQa3qTN8IKpCsY2f4QPW3SNDJsWkzkhmmtpCeL667pHB9ll16We4QOtvTg2pz6qmzlgoUml9rrguDKvB9FmZBPAkVUuF0rmHIqxNXBhcn5VNNpWkarmNTNLV8w06SHdlLk1RJpPU+RlNEJUt24efYYPYdkZvfoYJiAzPfkYVoidj7xiw7gZxkcUQGbi6hdroy8+YBZGxm61c79vPQBAZu2TcYoH6GRAbGYnUt0P1MyA2MkDqeywAQOxkDMXPYPsNXXw/w/fzQUxyyN7KG5yfMXjsyeOFH3aofsagAUJ/rfqwQ/UzBguQ6ltOQn+cH0N+hkeA0O/qCEGQn+EJIPX9+YxKfSwdS36GewihTuUIgSzLDpWNJz/DMbIsO8il+jVLykjq01XXkJ/hGCD027lMJtUP664hP8MhUKeaTy31e2/3FhGmtnVIEnUyF0d+41Hm+r4QkxxiA/QuUDqfnRgkyeU9gciomyD9JhfY7xIZPQIJyMWRVy7uA7QzzJAk6kTOF+/chgUiwzqOfJ8L7nx8jMjoESD065wx1Um2A7QzmoFL/Xz+2NKfscuE8/HxpscXUJ3RDCDVszL7dhpTuFQfsMMdpRWTOgVoZ7gho/ilOEj1aeeX31J9Jv8PvIgMr2QUEgQo3aOfgi+SQ9yQ8QID/e5x1ZwsiF2b6oQMoZ/Ojh9tbh7Fnl4Q+mVeZqkhYzt6baprMopgQhAQGe13Bv6dWQIzLnQe0Q5Gj36ncULoL33+UEA0O4PQEYiMgEBkBAQiIyAQGQGByAgMlE0FBkptAwPVGYGBir7AQBV4YCA5JDCQNhUYmqi2BNY5/gGzvkc1B9vyYAAAAABJRU5ErkJggg=='
            />
          </defs>
        )
      case 'plus-circle':
        return (
          <g fill='none'>
            <path
              d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 8V16' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M8 12H16' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'plus-circle-white':
        return (
          <g fill='none'>
            <path
              d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
              stroke='#F2F5FA'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 8V16' stroke='#F2F5FA' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M8 12H16' stroke='#F2F5FA' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'check-circle':
        return (
          <g fill='none'>
            <path
              d='M28 13.8493V14.9993C27.9985 17.6949 27.1256 20.3177 25.5117 22.4766C23.8977 24.6356 21.6291 26.2149 19.0442 26.9792C16.4593 27.7435 13.6966 27.6517 11.1681 26.7176C8.6396 25.7834 6.48082 24.057 5.0137 21.7957C3.54658 19.5344 2.84974 16.8594 3.0271 14.1697C3.20445 11.48 4.24651 8.91975 5.99785 6.87068C7.74919 4.82162 10.116 3.39357 12.7452 2.79952C15.3745 2.20548 18.1253 2.47726 20.5875 3.57434'
              stroke='#3B8B81'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M28 5L15.5 17.5125L11.75 13.7625' stroke='#3B8B81' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'folder':
        return (
          <g fill='none'>
            <path
              d='M44 38C44 39.0609 43.5786 40.0783 42.8284 40.8284C42.0783 41.5786 41.0609 42 40 42H8C6.93913 42 5.92172 41.5786 5.17157 40.8284C4.42143 40.0783 4 39.0609 4 38V10C4 8.93913 4.42143 7.92172 5.17157 7.17157C5.92172 6.42143 6.93913 6 8 6H18L22 12H40C41.0609 12 42.0783 12.4214 42.8284 13.1716C43.5786 13.9217 44 14.9391 44 16V38Z'
              stroke='#0D3B53'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'red-warning-circle':
        return (
          <g fill='none'>
            <path
              d='M12 22.75C17.5228 22.75 22 18.2728 22 12.75C22 7.22715 17.5228 2.75 12 2.75C6.47715 2.75 2 7.22715 2 12.75C2 18.2728 6.47715 22.75 12 22.75Z'
              stroke='#FF3434'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 6.75V14.75' stroke='#FF3434' strokeWidth='2' strokeLinecap='round' />
            <circle cx='12' cy='17.75' r='1' fill='#FF3434' />
          </g>
        )
      case 'x-circle':
        return (
          <g fill='none'>
            <path
              d='M15.6001 27.5C22.5037 27.5 28.1001 21.9036 28.1001 15C28.1001 8.09644 22.5037 2.5 15.6001 2.5C8.69654 2.5 3.1001 8.09644 3.1001 15C3.1001 21.9036 8.69654 27.5 15.6001 27.5Z'
              stroke='#FF3434'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M19.3501 11.25L11.8501 18.75' stroke='#FF3434' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M11.8501 11.25L19.3501 18.75' stroke='#FF3434' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'total':
        return (
          <g fill='none'>
            <g clipPath='url(#clip0_541_6768)'>
              <path
                d='M70.6958 36H49.8833L42.9458 48.8077H29.0708L22.1333 36H1.3208'
                stroke={mainColor}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M13.288 6.58455L1.3208 35.9995V61.6149C1.3208 63.8795 2.05171 66.0513 3.35275 67.6525C4.65378 69.2538 6.41836 70.1534 8.2583 70.1534H63.7583C65.5982 70.1534 67.3628 69.2538 68.6638 67.6525C69.9649 66.0513 70.6958 63.8795 70.6958 61.6149V35.9995L58.7286 6.58455C58.1543 5.16199 57.2689 3.96483 56.172 3.12767C55.0751 2.29051 53.8102 1.84655 52.5195 1.8457H19.497C18.2064 1.84655 16.9415 2.29051 15.8446 3.12767C14.7477 3.96483 13.8623 5.16199 13.288 6.58455Z'
                stroke={mainColor}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_541_6768'>
                <rect width='72' height='72' fill='white' transform='translate(0.00830078)' />
              </clipPath>
            </defs>
          </g>
        )
      case 'total-small':
        return (
          <g fill='none'>
            <path
              d='M22.0083 12H16.0083L14.0083 15H10.0083L8.0083 12H2.0083'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5.4583 5.11L2.0083 12V18C2.0083 18.5304 2.21901 19.0391 2.59409 19.4142C2.96916 19.7893 3.47787 20 4.0083 20H20.0083C20.5387 20 21.0474 19.7893 21.4225 19.4142C21.7976 19.0391 22.0083 18.5304 22.0083 18V12L18.5583 5.11C18.3927 4.77679 18.1375 4.49637 17.8213 4.30028C17.505 4.10419 17.1404 4.0002 16.7683 4H7.2483C6.87622 4.0002 6.51156 4.10419 6.19535 4.30028C5.87913 4.49637 5.62388 4.77679 5.4583 5.11Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'document':
        return (
          <g fill='none'>
            <path
              d='M42 6H18C16.4087 6 14.8826 6.63214 13.7574 7.75736C12.6321 8.88258 12 10.4087 12 12V60C12 61.5913 12.6321 63.1174 13.7574 64.2426C14.8826 65.3679 16.4087 66 18 66H54C55.5913 66 57.1174 65.3679 58.2426 64.2426C59.3679 63.1174 60 61.5913 60 60V24L42 6Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M42 6V24H60' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M48 39H24' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M48 51H24' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M30 27H27H24' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'document-small':
        return (
          <g fill='none'>
            <path
              d='M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M14 2V8H20' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M16 13H8' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M16 17H8' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M10 9H9H8' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'loader':
        return (
          <g fill='none'>
            <path d='M36 6V18' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M36 54V66' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M14.79 14.7891L23.28 23.2791' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M48.72 48.7207L57.21 57.2107' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M6 36H18' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M54 36H66' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M14.79 57.2107L23.28 48.7207' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M48.72 23.2791L57.21 14.7891' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'approved':
        return (
          <g fill='none'>
            <path d='M27 33L36 42L66 12' stroke='#0E5377' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M63 36V57C63 58.5913 62.3679 60.1174 61.2426 61.2426C60.1174 62.3679 58.5913 63 57 63H15C13.4087 63 11.8826 62.3679 10.7574 61.2426C9.63214 60.1174 9 58.5913 9 57V15C9 13.4087 9.63214 11.8826 10.7574 10.7574C11.8826 9.63214 13.4087 9 15 9H48'
              stroke='#0E5377'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'refresh':
        return (
          <g fill='none'>
            <path d='M23 4V10H17' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M1 20V14H7' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M3.51 8.99959C4.01717 7.56637 4.87913 6.28499 6.01547 5.27501C7.1518 4.26502 8.52547 3.55935 10.0083 3.22385C11.4911 2.88834 13.0348 2.93393 14.4952 3.35636C15.9556 3.77879 17.2853 4.5643 18.36 5.63959L23 9.99959M1 13.9996L5.64 18.3596C6.71475 19.4349 8.04437 20.2204 9.50481 20.6428C10.9652 21.0652 12.5089 21.1108 13.9917 20.7753C15.4745 20.4398 16.8482 19.7342 17.9845 18.7242C19.1209 17.7142 19.9828 16.4328 20.49 14.9996'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'refresh-white':
        return (
          <g fill='none'>
            <path d='M23 4V10H17' stroke='#FFFFFF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M1 20V14H7' stroke='#FFFFFF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M3.51 8.99959C4.01717 7.56637 4.87913 6.28499 6.01547 5.27501C7.1518 4.26502 8.52547 3.55935 10.0083 3.22385C11.4911 2.88834 13.0348 2.93393 14.4952 3.35636C15.9556 3.77879 17.2853 4.5643 18.36 5.63959L23 9.99959M1 13.9996L5.64 18.3596C6.71475 19.4349 8.04437 20.2204 9.50481 20.6428C10.9652 21.0652 12.5089 21.1108 13.9917 20.7753C15.4745 20.4398 16.8482 19.7342 17.9845 18.7242C19.1209 17.7142 19.9828 16.4328 20.49 14.9996'
              stroke='#FFFFFF'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'clock':
        return (
          <g fill='none'>
            <path
              d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 6V12L16 14' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'alert-triangle':
        return (
          <g fill='none'>
            <path
              d='M17.1503 6.43367L3.03361 30.0003C2.74256 30.5044 2.58856 31.0758 2.58693 31.6579C2.5853 32.2399 2.7361 32.8122 3.02432 33.3179C3.31255 33.8235 3.72815 34.2449 4.22979 34.5401C4.73143 34.8353 5.30161 34.9939 5.88361 35.0003H34.1169C34.6989 34.9939 35.2691 34.8353 35.7708 34.5401C36.2724 34.2449 36.688 33.8235 36.9762 33.3179C37.2645 32.8122 37.4153 32.2399 37.4136 31.6579C37.412 31.0758 37.258 30.5044 36.9669 30.0003L22.8503 6.43367C22.5532 5.94385 22.1348 5.53887 21.6356 5.25781C21.1364 4.97675 20.5732 4.8291 20.0003 4.8291C19.4274 4.8291 18.8642 4.97675 18.365 5.25781C17.8657 5.53887 17.4474 5.94385 17.1503 6.43367Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M20 15V21.6667' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M20 28.333H20.0163' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'line':
        return (
          <g fill='none'>
            <line x1='0.5' x2='0.5' y2='42' stroke='#919495' strokeOpacity='0.3' />
          </g>
        )
      case 'edit':
        return (
          <g fill='none'>
            <path
              d='M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13'
              stroke='#9D9FA0'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z'
              stroke='#9D9FA0'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'calendar':
        return (
          <g fill='none'>
            <path
              d='M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M16 2V6' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M8 2V6' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M3 10H21' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'gloveBox':
        return (
          <g fill='none'>
            <path
              d='M21 15.9999V7.9999C20.9996 7.64918 20.9071 7.30471 20.7315 7.00106C20.556 6.69742 20.3037 6.44526 20 6.2699L13 2.2699C12.696 2.09437 12.3511 2.00195 12 2.00195C11.6489 2.00195 11.304 2.09437 11 2.2699L4 6.2699C3.69626 6.44526 3.44398 6.69742 3.26846 7.00106C3.09294 7.30471 3.00036 7.64918 3 7.9999V15.9999C3.00036 16.3506 3.09294 16.6951 3.26846 16.9987C3.44398 17.3024 3.69626 17.5545 4 17.7299L11 21.7299C11.304 21.9054 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9054 13 21.7299L20 17.7299C20.3037 17.5545 20.556 17.3024 20.7315 16.9987C20.9071 16.6951 20.9996 16.3506 21 15.9999Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M3.27002 6.95996L12 12.01L20.73 6.95996'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 22.08V12' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'power':
        return (
          <g fill='none'>
            <path
              d='M18.3601 6.63965C19.6185 7.89844 20.4754 9.50209 20.8224 11.2478C21.1694 12.9936 20.991 14.803 20.3098 16.4474C19.6285 18.0918 18.4749 19.4972 16.9949 20.486C15.515 21.4748 13.775 22.0026 11.9951 22.0026C10.2152 22.0026 8.47527 21.4748 6.99529 20.486C5.51532 19.4972 4.36176 18.0918 3.68049 16.4474C2.99921 14.803 2.82081 12.9936 3.16784 11.2478C3.51487 9.50209 4.37174 7.89844 5.63012 6.63965'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M12 2V12' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'activityLevel':
        return (
          <g fill='none'>
            <path
              d='M21.5 10H17.5L14.5 19L8.5 1L5.5 10H1.5'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'toogleRight':
        return (
          <g clipPath='url(#clip0_625_931)' fill='none'>
            <path
              d='M16 1H8C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15H16C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M16 11C17.6569 11 19 9.65685 19 8C19 6.34315 17.6569 5 16 5C14.3431 5 13 6.34315 13 8C13 9.65685 14.3431 11 16 11Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'sitePlace':
        return (
          <g fill='none'>
            <path
              d='M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'countryLocation':
        return (
          <g fill='none'>
            <path
              d='M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'email':
        return (
          <g fill='none'>
            <path
              d='M20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M3 6L12.2571 13L21 6' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )

      case 'back':
        return (
          <g fill='none'>
            <path d='M26 20L22 24L26 28' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <rect x='0.5' y='0.5' width='47' height='47' rx='11.5' stroke='#CEDDF8' />
          </g>
        )
      case 'update':
        return (
          <g fill='none'>
            <path d='M10 16H5V21' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M19.4176 14.9971C18.8569 16.3848 17.9182 17.5874 16.7081 18.4682C15.498 19.3491 14.065 19.8727 12.5721 19.9797C11.0792 20.0868 9.58624 19.7728 8.26287 19.0736C6.9395 18.3744 5.83882 17.318 5.08594 16.0244'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M14 8H19V3' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M4.58203 9.00315C5.14272 7.61541 6.08146 6.41278 7.29157 5.53197C8.50169 4.65116 9.93462 4.12749 11.4275 4.02048C12.9204 3.91346 14.4134 4.2274 15.7368 4.92661C17.0601 5.62582 18.1608 6.68226 18.9137 7.97584'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'fail':
        return (
          <g fill='none'>
            <circle cx='16' cy='16' r='15.5' stroke='#FFDADF' />
            <path d='M12.5 19.5L19.5 12.5' stroke='#FF8393' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M19.5 19.5L12.5 12.5' stroke='#FF8393' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'play':
        return (
          <g fill='none'>
            <circle cx='16' cy='16' r='16' fill='#E5F9F3' />
            <path
              d='M12 11.7788C12 11.0022 12.848 10.5232 13.5131 10.9241L20.5172 15.1453C21.1609 15.5333 21.1609 16.4668 20.5172 16.8548L13.5131 21.0759C12.848 21.4768 12 20.9978 12 20.2212V11.7788Z'
              fill='#1DC198'
              stroke='#1DC198'
              strokeWidth='1.33063'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'gantt':
        return (
          <g fill={'none'}>
            <path
              d='M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M16 2V6' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M8 2V6' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M3 10H21' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'sites':
        return (
          <g fill={'none'}>
            <path
              d='M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'chambers':
        return (
          <g fill={'none'}>
            <path
              d='M12 8C16.9706 8 21 6.65685 21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5C3 6.65685 7.02944 8 12 8Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M3 5V19C3 20.66 7 22 12 22C17 22 21 20.66 21 19V5'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'orders':
        return (
          <g fill={'none'}>
            <path d='M22 12H16L14 15H10L8 12H2' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M5.45 5.11L2 12V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C20.5304 20 21.0391 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V12L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'logout':
        return (
          <g fill={'none'}>
            <path
              d='M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9'
              stroke='#F2F5FA'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path d='M16 17L21 12L16 7' stroke='#F2F5FA' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M21 12H9' stroke='#F2F5FA' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'users':
        return (
          <g fill={'none'}>
            <path
              d='M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799'
              stroke={this.props.fill}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'configurations':
        return (
          <g fill={'none'}>
            <path d='M4 21V14' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M4 10V3' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M12 21V12' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M12 8V3' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M20 21V16' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M20 12V3' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M1 14H7' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M9 8H15' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M17 16H23' stroke={this.props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'arrowBlackDown':
        return (
          <g fill='none'>
            <path d='M11 10L15 14L19 10' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      case 'arrowBlackUp':
        return (
          <g fill='none'>
            <path d='M11 14L15 10L19 14' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          </g>
        )
      // case "edit":
      //     return (
      //         <g fill="none">
      //             <path
      //                 d="M4 19.9998H8L19.2929 8.70696C19.6834 8.31643 19.6834 7.68327 19.2929 7.29274L16.7071 4.70696C16.3166 4.31643 15.6834 4.31643 15.2929 4.70696L4 15.9998V19.9998Z"
      //                 stroke="#1D355C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      //         </g>
      //
      //     );
      case 'blackEye':
        return (
          <g fill='none'>
            <path
              d='M2.58631 8.77881C4.36575 10.5478 7.46904 12.9999 10.9997 12.9999C14.5303 12.9999 17.6331 10.5478 19.4125 8.77881C19.8818 8.31226 20.1172 8.07819 20.2667 7.62012C20.3733 7.29328 20.3733 6.70674 20.2667 6.3799C20.1172 5.92181 19.8818 5.6877 19.4125 5.22111C17.633 3.45208 14.5303 1 10.9997 1C7.46904 1 4.36575 3.45208 2.58631 5.22111C2.11665 5.68802 1.8818 5.92165 1.73231 6.3799C1.62569 6.70673 1.62569 7.29328 1.73231 7.62012C1.8818 8.07837 2.11665 8.31189 2.58631 8.77881Z'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.99951 7C8.99951 8.10457 9.89494 9 10.9995 9C12.1041 9 12.9995 8.10457 12.9995 7C12.9995 5.89543 12.1041 5 10.9995 5C9.89494 5 8.99951 5.89543 8.99951 7Z'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'logOut':
        return (
          <g fill='none'>
            <path d='M12 15L15 12M15 12L12 9M15 12L4 12' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M9 7V5C9 4.44772 9.44772 4 10 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H10C9.44771 20 9 19.5523 9 19V17'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'note':
        return (
          <g fill='none'>
            <circle cx='16' cy='16' r='16' fill='#FFF4CC' />
            <path
              d='M20.667 10.667H11.3337C10.9655 10.667 10.667 10.9655 10.667 11.3337V20.667C10.667 21.0352 10.9655 21.3337 11.3337 21.3337H17.0575C17.2343 21.3337 17.4039 21.2634 17.5289 21.1384L21.1384 17.5289C21.2634 17.4039 21.3337 17.2343 21.3337 17.0575V11.3337C21.3337 10.9655 21.0352 10.667 20.667 10.667Z'
              stroke='#FFC700'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M21.3337 16.667H17.3337C16.9655 16.667 16.667 16.9655 16.667 17.3337V21.3337'
              stroke='#FFC700'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'trash':
        return (
          <g fill='none'>
            <path d='M13.6665 10.334L13.6665 16.1673' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M10.3335 10.334L10.3335 16.1673' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M17 7H7V18.6667C7 19.1269 7.3731 19.5 7.83333 19.5H16.1667C16.6269 19.5 17 19.1269 17 18.6667V7Z'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinejoin='round'
            />
            <path d='M5.3335 7H18.6668' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M14.4998 4.5H9.49984C9.0396 4.5 8.6665 4.8731 8.6665 5.33333V7H15.3332V5.33333C15.3332 4.8731 14.9601 4.5 14.4998 4.5Z'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'eye':
        return (
          <g fill='none'>
            <path
              d='M1.21956 8.82269C0.926816 8.31282 0.926814 7.6861 1.21955 7.17623C2.75984 4.49343 5.22354 2.75586 8.00001 2.75586C10.7765 2.75586 13.2402 4.4934 14.7804 7.17617C15.0732 7.68604 15.0732 8.31276 14.7804 8.82264C13.2402 11.5054 10.7765 13.243 7.99999 13.243C5.22353 13.243 2.75985 11.5055 1.21956 8.82269Z'
              stroke='#8996AA'
              strokeWidth='1.47475'
            />
            <path
              d='M9.96628 7.99942C9.96628 9.08539 9.08592 9.96575 7.99994 9.96575C6.91397 9.96575 6.03361 9.08539 6.03361 7.99942C6.03361 6.91344 6.91397 6.03308 7.99994 6.03308C9.08592 6.03308 9.96628 6.91344 9.96628 7.99942Z'
              stroke='#8996AA'
              strokeWidth='1.47475'
            />
          </g>
        )
      case 'link':
        return (
          <g fill='none'>
            <path d='M9.17188 14.8287L14.8287 9.17188' stroke='#1D355C' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M7.05014 11.293L5.63593 12.7072C4.07383 14.2693 4.07383 16.8019 5.63593 18.364C7.19803 19.9261 9.73069 19.9261 11.2928 18.364L12.707 16.9498'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.293 7.05063L12.7072 5.63642C14.2693 4.07432 16.8019 4.07432 18.364 5.63642C19.9261 7.19851 19.9261 9.73117 18.364 11.2933L16.9498 12.7075'
              stroke='#1D355C'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'files':
        return (
          <g fill='none'>
            <path
              d='M43.3333 70L13.3333 70C11.4924 70 10 68.5076 10 66.6667L10 23.3333C10 21.4924 11.4924 20 13.3333 20L31.9526 20C32.8367 20 33.6845 20.3512 34.3097 20.9763L45.6904 32.357C46.3155 32.9821 46.6667 33.83 46.6667 34.714V66.6667C46.6667 68.5076 45.1743 70 43.3333 70Z'
              stroke='#1D355C'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M33.333 20L33.333 13.3333C33.333 11.4924 34.8254 10 36.6663 10L55.2856 10C56.1697 10 57.0175 10.3512 57.6427 10.9763L69.0234 22.357C69.6485 22.9821 69.9997 23.83 69.9997 24.714V56.6667C69.9997 58.5076 68.5073 60 66.6663 60L46.6663 60'
              stroke='#1D355C'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M46.6667 36.6667L33.3333 36.6667C31.4924 36.6667 30 35.1743 30 33.3333L30 20'
              stroke='#1D355C'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M69.9997 26.6667L56.6663 26.6667C54.8254 26.6667 53.333 25.1743 53.333 23.3333L53.333 10'
              stroke='#1D355C'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )
      case 'pause':
        return (
          <g fill='none'>
            <circle cx='16' cy='16' r='16' fill='#E5F9F3' />
            <path
              d='M0 16C0 19.1645 0.938383 22.2579 2.69649 24.8891C4.45459 27.5203 6.95345 29.5711 9.87707 30.7821C12.8007 31.9931 16.0177 32.3099 19.1214 31.6926C22.2251 31.0752 25.0761 29.5513 27.3137 27.3137C29.5513 25.0761 31.0752 22.2251 31.6926 19.1214C32.3099 16.0177 31.9931 12.8007 30.7821 9.87706C29.5711 6.95345 27.5203 4.45459 24.8891 2.69649C22.2579 0.938384 19.1645 -3.77363e-08 16 0V2.02191C18.7646 2.02191 21.4671 2.84171 23.7658 4.37764C26.0645 5.91357 27.8561 8.09665 28.9141 10.6508C29.972 13.205 30.2489 16.0155 29.7095 18.727C29.1702 21.4385 27.8389 23.9291 25.884 25.884C23.9291 27.8389 21.4385 29.1702 18.727 29.7095C16.0155 30.2489 13.205 29.972 10.6508 28.9141C8.09665 27.8561 5.91357 26.0645 4.37764 23.7658C2.84171 21.4671 2.02191 18.7646 2.02191 16H0Z'
              fill='#18A280'
            />
            <path
              d='M18 11.667C18 11.1147 18.4477 10.667 19 10.667H21C21.5523 10.667 22 11.1147 22 11.667V20.3337C22 20.8859 21.5523 21.3337 21 21.3337H19C18.4477 21.3337 18 20.8859 18 20.3337V11.667Z'
              fill='#1DC198'
            />
            <path
              d='M10 11.667C10 11.1147 10.4477 10.667 11 10.667H13C13.5523 10.667 14 11.1147 14 11.667V20.3337C14 20.8859 13.5523 21.3337 13 21.3337H11C10.4477 21.3337 10 20.8859 10 20.3337V11.667Z'
              fill='#1DC198'
            />
          </g>
        )

      case 'alert':
        return (
          <g>
            <g clipPath='url(#clip0_214_4342)' fill={'none'}>
              <path
                d='M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z'
                stroke='#FF3932'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path d='M8 5.33334V8.00001' stroke='#FF3932' strokeLinecap='round' strokeLinejoin='round' />
              <path d='M8 10.6667H8.00667' stroke='#FF3932' strokeLinecap='round' strokeLinejoin='round' />
            </g>
            <defs>
              <clipPath id='clip0_214_4342'>
                <rect width='16' height='16' fill='white' />
              </clipPath>
            </defs>
          </g>
        )
      case 'pin':
        return (
          <g fill='none'>
            <path
              d='M18.2766 0.0139575C18.1251 0.0064692 17.9734 0.0177838 17.8247 0.0476418C17.2463 0.160725 16.7884 0.530051 16.5655 1.05938C16.1384 2.07419 16.0691 3.20376 16.3691 4.26301L13.964 6.66182C12.5928 5.91819 11.0414 5.57003 9.48327 5.65629C7.92518 5.74254 6.42183 6.25981 5.14134 7.15025C4.93087 7.29747 4.7554 7.48909 4.62734 7.71153C4.49928 7.93397 4.42177 8.18181 4.40029 8.43748C4.35209 8.97883 4.54488 9.50936 4.92685 9.89312L7.88382 12.8453L0.119077 23.0457C0.0514349 23.1351 0.0100873 23.2415 -0.000324962 23.3531C-0.0107373 23.4646 0.0101984 23.5769 0.0601317 23.6772C0.110065 23.7775 0.187019 23.862 0.282357 23.9211C0.377694 23.9802 0.487641 24.0116 0.599855 24.0117C0.731503 24.0103 0.859164 23.9664 0.963752 23.8866L11.1806 16.1356L14.1363 19.0866C14.3255 19.2759 14.5541 19.4215 14.8058 19.5129C15.0575 19.6044 15.3263 19.6396 15.5931 19.6159C15.8495 19.594 16.0979 19.516 16.3207 19.3875C16.5435 19.259 16.7353 19.0832 16.8824 18.8724C17.7743 17.5941 18.2926 16.0933 18.3794 14.5378C18.4662 12.9823 18.1181 11.4333 17.3741 10.064L19.8008 7.64108C20.8451 7.92412 21.9543 7.85044 22.9518 7.43175C23.2116 7.32337 23.4402 7.15177 23.6165 6.9326C23.7929 6.71344 23.9115 6.45368 23.9616 6.17701C24.0206 5.88139 24.0058 5.5758 23.9184 5.28727C23.831 4.99874 23.6736 4.73619 23.4603 4.52286L19.4815 0.548097C19.16 0.227181 18.7306 0.0368415 18.2766 0.0139575ZM18.0549 1.229C18.1571 1.20889 18.2627 1.21405 18.3624 1.24404C18.4622 1.27402 18.5531 1.32792 18.6272 1.40103L22.606 5.37339C22.6793 5.44739 22.7335 5.53806 22.7639 5.6376C22.7944 5.73714 22.8001 5.84257 22.7807 5.94483C22.7673 6.02733 22.7333 6.10515 22.682 6.17115C22.6306 6.23715 22.5635 6.28921 22.4867 6.32257C21.6417 6.67463 20.6955 6.69908 19.8334 6.39115C19.7258 6.35342 19.6097 6.34696 19.4985 6.37252C19.3874 6.39807 19.2858 6.45459 19.2056 6.53551L16.1956 9.53944C16.0993 9.63546 16.0384 9.76114 16.0226 9.89609C16.0069 10.031 16.0373 10.1674 16.1089 10.2829C16.8494 11.4776 17.2236 12.8624 17.1855 14.2668C17.1474 15.6712 16.6986 17.0338 15.8944 18.1867C15.8475 18.2525 15.7868 18.3072 15.7164 18.3469C15.646 18.3866 15.5677 18.4104 15.4871 18.4165C15.3958 18.4249 15.3037 18.4131 15.2175 18.3819C15.1312 18.3507 15.053 18.3009 14.9882 18.236L11.724 14.9759C11.7059 14.9518 11.6963 14.9229 11.6746 14.9013L9.1201 12.3509C9.09962 12.328 9.0695 12.3208 9.0454 12.3028L5.77996 9.04259C5.71509 8.97769 5.66537 8.89929 5.63433 8.81299C5.6033 8.72669 5.59172 8.63462 5.60043 8.54334C5.60637 8.46281 5.63009 8.38459 5.66988 8.31429C5.70967 8.24399 5.76454 8.18335 5.83057 8.13672C7.03795 7.29612 8.47475 6.84595 9.9467 6.84709C11.2601 6.84709 12.5807 7.20679 13.7483 7.92619C13.8638 7.99681 13.9997 8.02656 14.1341 8.01062C14.2686 7.99469 14.3937 7.93401 14.4894 7.83837L17.4801 4.85249C17.5619 4.7716 17.6187 4.66901 17.6439 4.55686C17.6691 4.44472 17.6616 4.32772 17.6223 4.2197C17.2967 3.34821 17.3152 2.38571 17.6741 1.52735C17.7077 1.44995 17.7602 1.38214 17.8266 1.33004C17.8931 1.27795 17.9716 1.24323 18.0549 1.229ZM8.74416 13.7007L10.3214 15.2754L3.75323 20.2583L8.74416 13.7019V13.7007Z'
              fill={mainColor}
            />
          </g>
        )
      case 'reset':
        return (
          <g fill='none'>
            <path d='M1 4V10H7' stroke={mainColor} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
              d='M3.51 15.0004C4.15839 16.8408 5.38734 18.4206 7.01166 19.5018C8.63598 20.583 10.5677 21.107 12.5157 20.9949C14.4637 20.8828 16.3226 20.1406 17.8121 18.8802C19.3017 17.6198 20.3413 15.9094 20.7742 14.0068C21.2072 12.1042 21.0101 10.1124 20.2126 8.33154C19.4152 6.55068 18.0605 5.07723 16.3528 4.1332C14.6451 3.18917 12.6769 2.8257 10.7447 3.09755C8.81245 3.36941 7.02091 4.26186 5.64 5.64044L1 10.0004'
              stroke={mainColor}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        )

      default:
        return ''
    }
  }

  render() {
    let {
      name = null,
      svgname = '',
      style = {},
      onClick = null,
      fill = 'rgb(0,0,0)',
      viewBox = '',
      width = '100%',
      className = 'mhd-icons',
      subClass = '',
      size = '',
      height = '100%',
      onMouseEnter,
      onMouseLeave,
      onMouseDown,
      onMouseUp
    } = this.props
    return (
      <svg
        name={name ? name : 'oppa'}
        width={width}
        style={style}
        height={height}
        onMouseEnter={(e) => (onMouseEnter ? onMouseEnter(e) : {})}
        onMouseLeave={(e) => (onMouseLeave ? onMouseLeave(e) : {})}
        onMouseDown={(e) => (onMouseDown ? onMouseDown(e) : {})}
        onMouseUp={(e) => (onMouseUp ? onMouseUp(e) : {})}
        onClick={onClick}
        type={'image/svg+xml'}
        className={`${className} ${size} ${subClass}`}
        xmlns='http://www.w3.org/2000/svg'
        viewBox={viewBox || this.getViewBox(svgname)}
        fill={fill === '' ? 'rgb(0,0,0)' : fill}
      >
        {this.getPath(svgname, this.props)}
      </svg>
    )
  }
}

export default SVGraphics
